import React, { useEffect, useMemo, useState } from "react";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { useNavigate } from "react-router-dom";
import api from "./Axios/api";
import { Eye, Trash2, ClipboardList, CircleX } from "lucide-react";
import Swal from "sweetalert2";
const PendingPoList = () => {
  const [data, setData] = useState([]);
  const [qtyList, setQtyList] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [month, setMonth] = useState("");
  const navigation = useNavigate();
  const getData = async () => {
    try {
      const res = await api.get(`/po-detail/get?month=${month}&status=1`);
      const sortedData = res.data.sort(
        (a, b) => new Date(b.po_date) - new Date(a.po_date)
      );
      return setData(sortedData);
    } catch (error) {
      console.log(error);
    }
  };

  const branchMapping = {
    "666c0f5ebeca5ab2c65b2c85": "INSULATION",
    "666c0f5ebeca5ab2c65b2c86": "PROJECTS",
    "666c0f5ebeca5ab2c65b2c87": "ROCKFIBRE",
  };
  useEffect(() => {
    getData();
  }, [month]);
  useEffect(() => {
    const now = new Date();
    const year = now.getFullYear();
    const monthNum = String(now.getMonth() + 1).padStart(2, "0");
    const currentMonth = `${year}-${monthNum}`;
    setMonth(currentMonth);
  }, []);

  const handleQtylist = async (poId) => {
    try {
      const res = await api.get(`/po-detail/get-po-qty/${poId}`);
      setQtyList(res.data);
      setOpenModal(true);
    } catch (error) {
      console.error("internal server error", error);
    }
  };
  const handleClosePO = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: `Do you want to close PO ?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, close it!",
    });

    if (result.isConfirmed) {
      try {
        await api.patch(`/po-detail/close-status/${id}`);
        Swal.fire({
          icon: "success",
          title: "PO closed",
          text: `PO has been closed successfully.`,
          timer: 1000,
          showConfirmButton: false,
        });
        getData();
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error when deleting PO",
          text: error.response?.data?.message || "Something went wrong.",
        });
      }
    }
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "po_date",
        header: "Date",
        size: 150,
        Cell: ({ cell }) =>
          new Intl.DateTimeFormat("en-GB").format(new Date(cell.getValue())),
      },
      {
        accessorKey: "po_number",
        header: "PO NO.",
        size: 150,
      },
      {
        accessorKey: "party_name",
        header: "PARTY",
        size: 150,
      },
      {
        accessorKey: "created_by_name",
        header: "Created by",
        size: 150,
      },
      {
        accessorKey: "po_branch",
        header: "PO Branch",
        size: 150,
        Cell: ({ cell }) => {
          const branchId = cell.getValue();
          const branchName = branchMapping[branchId] || "UNKNOWN";

          return <div className="max-h-10 overflow-y-auto">{branchName}</div>;
        },
      },
      {
        accessorKey: "_id",
        header: "Action",
        size: 150,
        Cell: ({ cell }) => (
          <div className="flex items-center gap-3">
            <div onClick={() => handleQtylist(cell.getValue())}>
              <button>
                <ClipboardList size={20} />
              </button>
            </div>
            <div
              onClick={() =>
                navigation(`/create-po-form`, {
                  state: { poId: cell.getValue() },
                })
              }
            >
              <button>
                <Eye size={20} />
              </button>
            </div>
            <div onClick={() => handleClosePO(cell.getValue())}>
              <button>
                <Trash2 size={18} />
              </button>
            </div>
          </div>
        ),
      },
    ],
    [month]
  );
  const table = useMaterialReactTable({
    columns,
    data: data,
  });
  return (
    <div className="flex-1 px-5 w-full justify-center items-center">
      <div className="px-2 py-4 rounded-md bg-[#fdfdfd] shadow my-2">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center w-full px-3 gap-4">
          <div className="text-lg text-violet-500 font-bold">
            Pending-Po List
          </div>
          <div className="mb-4 space-x-2">
            <input
              type="month"
              value={month}
              onChange={(e) => {
                setMonth(e.target.value);
              }}
              className="border rounded px-2 py-1"
            />
          </div>
        </div>
      </div>

      <div className="w-full min-h-[500px] rounded-md shadow bg-[#fdfdfd]">
        <MaterialReactTable table={table} />
      </div>
      {openModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 "
          onClick={() => setOpenModal(false)}
        >
          {/* Modal Box */}
          <div className="bg-white w-full max-w-3xl rounded-xl shadow-lg p-6">
            {/* Header */}
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-xl font-semibold text-gray-800">
                Item Quantity List
              </h3>
              <button
                onClick={() => setOpenModal(false)}
                className="text-red-500 hover:text-red-600 text-2xl"
              >
                <CircleX size={26} />
              </button>
            </div>

            {/* Table */}
            <div className="overflow-x-auto">
              <table className="w-full border border-gray-300 text-sm">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="border px-3 py-2 text-left">S.No</th>
                    <th className="border px-3 py-2 text-left">Item Title</th>
                    <th className="border px-3 py-2 text-right">Quantity</th>
                    <th className="border px-3 py-2 text-right">Balance Qty</th>
                  </tr>
                </thead>

                <tbody>
                  {qtyList.length > 0 ? (
                    qtyList.map((item, index) => (
                      <tr key={index} className="hover:bg-gray-50 transition">
                        <td className="border px-3 py-2">{index + 1}</td>
                        <td className="border px-3 py-2">{item.item_title}</td>
                        <td className="border px-3 py-2 text-right">
                          {item.purchase_qty}
                        </td>
                        <td className="border px-3 py-2 text-right">
                          {item.rem_qty > 0 ? item.rem_qty : ""}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="4"
                        className="border px-4 py-3 text-center text-gray-500"
                      >
                        No data available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          {openModal && (
            <div
              className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
              onClick={() => setOpenModal(false)}
            >
              {/* Modal Box */}
              <div
                className="bg-white w-full max-w-3xl rounded-xl shadow-lg p-6"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-xl font-semibold text-gray-800">
                    Item Quantity List
                  </h3>
                  <button
                    onClick={() => setOpenModal(false)}
                    className="text-red-500 hover:text-red-600 text-2xl"
                  >
                    <CircleX size={26} />
                  </button>
                </div>

                <div className="overflow-x-auto">
                  <table className="w-full border border-gray-300 text-sm">
                    <thead className="bg-gray-100">
                      <tr>
                        <th className="border px-3 py-2">S.No</th>
                        <th className="border px-3 py-2">Item Title</th>
                        <th className="border px-3 py-2 text-right">
                          Quantity
                        </th>
                        <th className="border px-3 py-2 text-right">
                          Balance Qty
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {qtyList.length > 0 ? (
                        qtyList.map((item, index) => (
                          <tr key={index}>
                            <td className="border px-3 py-2">{index + 1}</td>
                            <td className="border px-3 py-2">
                              {item.item_title}
                            </td>
                            <td className="border px-3 py-2 text-right">
                              {item.purchase_qty}
                            </td>
                            <td className="border px-3 py-2 text-right">
                              {item.rem_qty > 0 ? item.rem_qty : ""}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan="4"
                            className="border px-4 py-3 text-center text-gray-500"
                          >
                            No data available
                          </td>
                        </tr>
                      )}
                      {}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
export default PendingPoList;
